import { render, staticRenderFns } from "./business-glossary-screen.vue?vue&type=template&id=850579d6&"
import script from "./business-glossary-screen.vue?vue&type=script&lang=js&"
export * from "./business-glossary-screen.vue?vue&type=script&lang=js&"
import style0 from "./business-glossary-screen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports